export default "__VITE_ASSET__ccef59bb__"